import React, { useContext, useEffect, useMemo, useState } from 'react'
import { InternshipsManagerContext } from '../../../../Context/InternshipsManager/InternshipsManagerProvider'
import { BACKEND_DATE_FORMAT } from '../../../../utils/constants'
import { callFunctionIfDefined } from '../../../../utils/functionHelper'
import InternshipValidationButton from '../../ShiftsManager/InternshipValidationButton'
import SchoolDateCell from '../DateCell/SchoolDateCell'
import StudentQuickMenu from '../StudentQuickMenu'
import { getSchoolInternshipData } from '../utils/componentGetters'
import { getIndexesByColumns, getValidationTooltipText } from '../utils/utils'
import { Modal, Tooltip } from 'antd'
import SchoolStatesSelector from '../../Selectors/StatesSelector/SchoolStatesSelector'

const DEFAULT_INDEXES = { startIndex: 0, lastIndex: 0 }

const SchoolInternshipLine = ({ getQuotasState, onLineHover }) => {
  const { dataProvider, internshipProvider, setInternshipToEdit, periodType } = useContext(InternshipsManagerContext)
  const {
    dateColumns, user, onInternshipSelected, onStudentSelected,
    onInternshipDelete, setChat, setInternshipToValidate, t, totalsMessageUnreadByInternships
  } = useContext(dataProvider.context)
  const {
    internship, overlaping, onPeriodUpdate, onUpdate, handleStateChange, handleDuplicateInternship, setOverlaping
  } = useContext(internshipProvider.context)

  const [isHovered, setIsHovered] = useState(false)
  const [periodIndexes, setPeriodIndexes] = useState(DEFAULT_INDEXES)
  const InternshipData = useMemo(() => getSchoolInternshipData(user.context), [user.context])

  const isInternshipRequest = useMemo(() => !!internship.individualInternshipRequest, [internship])

  useEffect(() => {
    if (internship.startDate && internship.endDate && periodType) {
      setPeriodIndexes(getIndexesByColumns(internship, dateColumns, periodType))
    }
  }, [internship, dateColumns, periodType])

  const updatePeriod = ({ startDate, endDate }, direction, index) => {
    const newInternship = {
      ...internship,
      startDate: typeof startDate === 'undefined'
        ? internship.startDate
        : startDate.format(BACKEND_DATE_FORMAT),
      endDate: typeof endDate === 'undefined'
        ? internship.endDate
        : endDate.format(BACKEND_DATE_FORMAT)
    }

    callFunctionIfDefined(onPeriodUpdate, [newInternship])
  }

  const handleLineHover = () => {
    setIsHovered(true)
    onLineHover(periodIndexes)
  }

  const handleLineLeave = () => {
    setIsHovered(false)
  }

  return (
    <tr
      className='internship-line'
      onMouseOver={handleLineHover}
      onMouseLeave={handleLineLeave}
    >
      <Modal
        footer={null}
        visible={overlaping}
        title={t('Warning!')}
        onCancel={() => setOverlaping(false)}
      >
        {t('This student is already doing an internship during this period.')}
      </Modal>
      <td>
        <div className='internship-card-old'>
          <Tooltip title={isInternshipRequest ? t('internship_line.internship_request_info') : ''}>
            <div
              className='internship-card-old-div'
              style={
                internship.individualInternshipRequest
                  ? { border: '2px solid #ED7F10', marginTop: '3vh', marginBottom: '3vh', borderRadius: '5px', backgroundColor: 'rgba(237, 127, 16, 0.4)' }
                  : {}
              }
            >
              <div className='quick-menu-container'>
                <StudentQuickMenu
                  noMargin
                  internship={internship}
                  onSelectedStudentInfo={onStudentSelected}
                  onSelectedInternshipInfo={onInternshipSelected}
                  onSelectedInternshipChat={setChat}
                  onInternshipDelete={onInternshipDelete}
                  onDuplicateInternship={handleDuplicateInternship}
                  totalsMessageUnreadByInternships={totalsMessageUnreadByInternships}
                />
              </div>
              <InternshipData
                disabled={isInternshipRequest}
                internship={internship}
                onInternshipUpdate={onUpdate}
              />
              <div className='status-validation-wrapper'>
                <SchoolStatesSelector
                  internship={internship}
                  onChange={handleStateChange}
                />
                {user.canValidateInternship && internship.shifts && internship.shifts.length > 0 &&
                  <InternshipValidationButton
                    validateButtonTooltip={t(getValidationTooltipText(internship))}
                    internship={internship}
                    onDisplayValidationDrawer={setInternshipToValidate}
                  />}
              </div>
            </div>
          </Tooltip>
        </div>
      </td>
      {dateColumns.map((dates, index) => {
        return (
          <SchoolDateCell
            key={index}
            disabled={isInternshipRequest}
            startDate={dates.startDate}
            endDate={dates.endDate}
            index={index}
            isHovered={isHovered}
            periodIndexes={periodIndexes}
            onPeriodChange={updatePeriod}
            onDoubleClick={setInternshipToEdit}
          />
        )
      })}
    </tr>
  )
}

export default SchoolInternshipLine
